export enum MessagePosition{
    fix,
    float
}